import { groupInterface } from 'src/app/util/interfaces/group';
import { Component, OnInit } from '@angular/core';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CustomerInformationService } from './service/customer-information.service';
import { forkJoin } from 'rxjs';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { customerInterface, permissionsInterface } from 'src/app/util/interfaces/customer';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { faCheckSquare, faSortDown, faSortUp, faSquare } from '@fortawesome/free-solid-svg-icons';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-customer-information',
	templateUrl: './customer-information.component.html',
	styleUrl: './customer-information.component.scss',
})
export class CustomerInformationComponent implements OnInit {
	icons = {
		faSortDown: faSortDown,
		faSortUp: faSortUp,
		faCheckSquare: faCheckSquare,
		faSquare: faSquare,
	};

	labels: LabelsInterface = {
		lbl_geral_atualizar: '',
		lbl_preencha_todos_asteriscos: '',
		lbl_successful_updated: '',
		lbl_chamado_informacoes_gerais: '',
		lbl_geral_grupo: 'group',
		lbl_grupos_reabertura_chamado: 'Ticket Reopening Groups',
		lbl_cadastro_permissoes: '',
		lbl_geral_descricao: '',
		lbl_geral_ativo: '',
	};

	constructor(
		private LabelsService: LabelsService,
		private CustomerInformationService: CustomerInformationService,
		private ProfileService: ProfileService,
		private NotificationService: NotificationService
	) {
		this.permissionFilterCallback = this.permissionFilterCallback.bind(this);
	}

	customerForm: genericFormInterface[] = [];
	customerDataMemory: customerInterface;

	contractedGroupList: groupInterface[] = [];
	searchHeader: mspTableHeaderI[] = [
		{ name: 'group_name', value: 'lbl_geral_grupo', colType: 'text' },
		{ name: 'icon', value: 'lbl_geral_ativo', colType: 'icon' },
	];

	customerPermissions: permissionsInterface[] = [];

	areRequiredFulfilled = false;
	triggerRequired = false;

	isLoadingLabels = true;
	isLoadingCustomerForm = true;
	isLoadingContractedGroup = true;
	isLoadingCustomerPermissions = true;

	isUpdatingCustomer = false;
	isUpdatingPermissions = false;

	selectedTab = 'infoCustomer';

	permissionSort = {
		filterPermission: '',
		filterDescription: '',
		sortName: 'permission',
		sortOrder: [false, false, false], //start as down, down, down
	};

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		forkJoin([
			this.CustomerInformationService.getCustomerForm(),
			this.CustomerInformationService.getCustomerData(this.ProfileService.userData().idCustomer),
			this.CustomerInformationService.getCustomerPermissions(),
		]).subscribe({
			next: (forkRes) => {
				const formData = forkRes[0];
				const customerData = forkRes[1];
				this.customerDataMemory = forkRes[1];
				const customerPermission = forkRes[2];

				for (const formItem of formData) {
					if (customerData[formItem.name]) {
						if (formItem.inputType == 'multi-select') {
							formItem.rawValues = customerData[formItem.name];
							for (const item of formItem.items) {
								if (formItem.rawValues.includes(item.values[0])) {
									formItem.values.push(item);
								}
							}
						} else if (Array.isArray(customerData[formItem.name])) formItem.values = customerData[formItem.name];
						else formItem.values[0] = customerData[formItem.name];
					}
				}

				this.customerForm = formData;
				this.customerPermissions = customerPermission;
			},
			complete: () => {
				this.isLoadingCustomerForm = false;
				this.isLoadingCustomerPermissions = false;
			},
		});

		this.getAllContractedSolutionAreas();
	}

	areRequiredFieldsFulfilled(): boolean {
		let areRequiredFieldsFulfilled = true;
		for (let index = 0; index < this.customerForm.length; index++) {
			const formItem = this.customerForm[index];
			if (
				formItem.required == true &&
				formItem.hidden != false &&
				(formItem.values[0] == '' || formItem.values[0] == '-1' || formItem.values[0] == undefined)
			) {
				areRequiredFieldsFulfilled = false;
				break;
			}
		}

		return areRequiredFieldsFulfilled;
	}

	updateCustomer(): void {
		if (!this.areRequiredFieldsFulfilled()) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			this.triggerRequired = true;
			setTimeout(() => {
				this.triggerRequired = false;
			}, 100);
			return;
		}

		if (this.isUpdatingCustomer) return;
		this.isUpdatingCustomer = true;

		const body = JSON.parse(JSON.stringify(this.customerDataMemory));
		for (let index = 0; index < this.customerForm.length; index++) {
			const formItem = this.customerForm[index];
			if (body[formItem.name] == undefined) continue;
			body[formItem.name] =
				formItem.inputType == 'multi-input' || formItem.inputType == 'multi-select' ? formItem.values : formItem.values[0];
		}

		this.CustomerInformationService.updateCustomer(body).subscribe((res) => {
			this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			this.isUpdatingCustomer = false;
		});
	}

	getAllContractedSolutionAreas(): void {
		this.CustomerInformationService.getContractedSolutionAreas().subscribe((data) => {
			this.contractedGroupList = data.map((item) => ({
				...item,
				icon: item.active === 1 ? 'faCheckSquare' : 'faSquare',
			}));
			this.isLoadingContractedGroup = false;
		});
	}

	updateContractedGroup(row: any): void {
		row[0].active = row[0].active === 0 ? 1 : 0;
		this.CustomerInformationService.updateContractedSolutionAreas(row[0]).subscribe(() => {
			this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			this.getAllContractedSolutionAreas();
		});
	}

	updateCustomerPermission(): void {
		if (this.isUpdatingPermissions) return;

		const allowedPermissions = this.customerPermissions.map((permission) => {
			if (permission.allowed == 1) return permission;
		});
		this.isUpdatingPermissions = true;
		this.CustomerInformationService.updateCustomerServices(allowedPermissions).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			},
			complete: () => {
				this.isUpdatingPermissions = false;
			},
		});
	}

	sortPermissions(): void {
		//Essa concatenação toda é só pra escrever availableEnduserPermissions ou availableAnalystPermissions
		this.customerPermissions.sort((a, b) => {
			if (this.permissionSort.sortName === 'permission') {
				if (a.permission > b.permission) {
					return this.permissionSort.sortOrder[0] ? -1 : 1;
				}
				if (b.permission > a.permission) {
					return this.permissionSort.sortOrder[0] ? 1 : -1;
				}
				return 0;
			}

			if (this.permissionSort.sortName === 'description') {
				if (a.description > b.description) {
					return this.permissionSort.sortOrder[1] ? -1 : 1;
				}
				if (b.description > a.description) {
					return this.permissionSort.sortOrder[1] ? 1 : -1;
				}
				return 0;
			}

			if (this.permissionSort.sortName === 'active') {
				if (a.allowed > b.allowed) return this.permissionSort.sortOrder[2] ? 1 : -1;
				if (a.allowed < b.allowed) return this.permissionSort.sortOrder[2] ? -1 : 1;
				return 0;
			}
		});
	}

	permissionFilterCallback(permission: permissionsInterface) {
		if (this.permissionSort.filterPermission.trim() == '' && this.permissionSort.filterDescription.trim() == '') return true;

		if (this.permissionSort.filterPermission.trim() != '' && this.permissionSort.filterDescription.trim() != '')
			return (
				permission.permission.includes(this.permissionSort.filterPermission) &&
				permission.description.includes(this.permissionSort.filterDescription)
			);
		if (this.permissionSort.filterPermission.trim() != '') return permission.permission.includes(this.permissionSort.filterPermission);
		if (this.permissionSort.filterDescription.trim() != '')
			return permission.description.includes(this.permissionSort.filterDescription);
	}
}
